import { SynPerfis } from './synPerfis'

export const WHATSAPP_SYN_NUMERO = '5511992595466'
export const WHATSAPP_SYN_EXIBICAO = '+55 11 99259-5466'
export const WHATSAPP_MENSAGEM_ATENDIMENTO_PADRAO =
  'Olá! Quero iniciar meu atendimento com a SYN Saúde.'

export function getLinkWhatsApp(
  mensagem: string = WHATSAPP_MENSAGEM_ATENDIMENTO_PADRAO,
  numero: string = WHATSAPP_SYN_NUMERO
): string {
  return `https://api.whatsapp.com/send?phone=${numero}&text=${encodeURIComponent(
    mensagem
  )}`
}

/** Perfis internos pertencentes à equipe da SYN */
export const PERFIS_EQUIPE_SYN: string[] = [
  SynPerfis.OPERACIONAL,
  SynPerfis.SUPER_ADMIN,
  SynPerfis.COMERCIAL_B2B,
  SynPerfis.COMERCIAL_MEDICOS,
  SynPerfis.COMERCIAL_EXPANSAO,
  SynPerfis.FINANCEIRO
]

export function isPerfilSyn(perfilAtual?: string | null): boolean {
  if (!perfilAtual) return false
  return PERFIS_EQUIPE_SYN.includes(perfilAtual)
}

/**
 * Regra de exibição do botão flutuante de WhatsApp:
 * 1. Não logado -> Deve aparecer em todas as telas.
 * 2. Perfis da SYN -> NÃO deve aparecer.
 * 3. Outros perfis (médico, paciente, parceiro, hospital, secretária) -> Deve aparecer em todas as telas.
 */
export function deveExibirBotaoWhatsapp(options: {
  signed?: boolean
  perfilAtual?: string | null
}): boolean {
  const { signed, perfilAtual } = options

  // Quando não estiver logado -> deve aparecer
  if (!signed) {
    return true
  }

  // Não deve aparecer para perfis da SYN
  if (isPerfilSyn(perfilAtual)) {
    return false
  }

  // Aparece em todas as telas para os outros perfis
  return true
}

/** Mantido para compatibilidade retroativa */
export function isRotaAcessoOuProposta(
  pathname?: string,
  signed?: boolean
): boolean {
  if (!pathname) return false

  if (signed === false) {
    return true
  }

  const normalized = pathname.toLowerCase()

  const rotasAcessoExatas = [
    '/sign-in',
    '/esqueci-senha',
    '/mfa-etapa-1',
    '/mfa-etapa-2',
    '/definir-senha',
    '/definir-senha-token',
    '/alterar-senha',
    '/alterar-senha-master',
    '/configurar-acesso-medico',
    '/configurar-acesso-parceiro',
    '/cadastro',
    '/new-cadastro',
    '/cadastro-sucesso',
    '/selecionar-perfil',
    '/selecionar-setor-parceiro',
    '/termos-de-uso',
    '/termos-de-uso-txt',
    '/politica-privacidade',
    '/politica-privacidade-txt'
  ]

  if (rotasAcessoExatas.includes(normalized)) {
    return true
  }

  if (
    normalized.startsWith('/primeiro-acesso') ||
    normalized.startsWith('/cadastro')
  ) {
    return true
  }

  if (
    normalized.includes('proposta') ||
    normalized.includes('pagamento') ||
    normalized.includes('financiamento') ||
    normalized === '/como-funciona-pagamento' ||
    normalized === '/instrucoes-nota-fiscal'
  ) {
    return true
  }

  return false
}
